/*
 * @Author: ken yang
 * @Date: 2023-05-31 17:36:33
 * @LastEditTime: 2023-05-31 17:38:34
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/utils/globalFunc/borwserLang.js
 */
const lang = () => {
  const rowLang = navigator.language || navigator.userLanguage
  if (rowLang.includes('zh')) {
    return LANGCN
  } else if (rowLang.includes('ko')) {
    return LANGKO
  } else if (rowLang.includes('ja')) {
    return LANGJA
  }
  return LANGEN
}

export default lang
